module.exports = __webpack_public_path__ + "static/img/48成都照明.0b90713.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/48成都照明.jpg
// module id = Zs1s
// module chunks = 0